import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./PaymentInfo.module.css";

const PaymentInfo = () => {
  const infoItems = ["cancel_at_any_time", "no_hidden_fees", "secure_payment"];
  const paymentIcons = ['locked', 'visa', 'mastercard'];

  return (
    <LanguageContext.Consumer>
      {({ data, language: lang }) => {
        const t = (key) => data?.[key]?.[lang];

        return (
          <div className={styles.wrapper}>
            <div className={styles.icons}>
                {paymentIcons.map((icon) => (
                <img key={icon} src={`/assets/subscriptions/${icon}.svg`} alt="" />
              ))}
            </div>
            <div className={styles.infoText}>
              {infoItems.map((text, idx) => (
                <span key={text}>
                  <span>{t(text)}</span>
                  {idx < infoItems.length - 1 && <span className={styles.dot}>•</span>}
                </span>
              ))}
            </div>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  )
};

export default PaymentInfo;